import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import dayjs from "dayjs";
import { Dictionary } from "src/app/store/models/common_types";
import { AppState } from "src/app/store/state/app.state";
import { ResearchPageDataService } from "../research-page-data.service";
import print from "print-js";
import { faPhoneAlt, faSpinner } from "@fortawesome/pro-solid-svg-icons";
import { faEnvelope } from "@fortawesome/pro-light-svg-icons";
import {
  PrintDocResponse,
  RevenueLineInfo,
  Ticker,
} from "../research-page.model";
import { AppService } from "src/app/app.service";
import { ResearchViewerComponent } from "../research-viewer/research-viewer.component";
import { NzMessageService } from "ng-zorro-antd/message";
import {
  VAIconRegistryService,
  arrowCircleLeft,
  arrowCircleRight,
  download,
  print as printIcon,
} from "@va/core-library/icons";
@Component({
  selector: "app-research-page",
  templateUrl: "./research-page.component.html",
  styleUrls: ["./research-page.component.scss"],
  host: { class: "research-page-component" },
  encapsulation: ViewEncapsulation.None,
})
export class ResearchPageComponent implements OnInit {
  apiEP: string = window.apiUrl;
  loading = true;
  isPrinting = false;
  ticker: string;
  researchDocId: string;
  docInfo: Dictionary<any>;
  analystList: Array<Dictionary<any>> = [];
  selectedTicker: Ticker;
  brokerName: string;
  publishedDate: Date;
  documentType: string;
  companies: Array<any> = [];
  modelDataAPICallCounter = 0;
  modelDataAPICallHead = 0;
  publisherId: number;
  modelsData: Array<any> = [];
  modelsDataFilteredSorted: Array<any> = [];
  lineItem: RevenueLineInfo;
  isRightsideBarCollapsed = false;
  showRightSidebar = true;
  faPhoneAlt = faPhoneAlt;
  faEnvelope = faEnvelope;
  faSpinner = faSpinner;
  tickerSelectorObj: {
    ticker: string;
    researchDocId: string;
    documentType: string;
  };
  @ViewChild(ResearchViewerComponent)
  researchViewerComponent: ResearchViewerComponent;
  constructor(
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private dataService: ResearchPageDataService,
    private appService: AppService,
    private message: NzMessageService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([
      download,
      printIcon,
      arrowCircleLeft,
      arrowCircleRight,
    ]);
  }

  ngOnInit(): void {
    this.selectedTicker = {
      name: "",
      symbologycompanyid: 0,
      ticker: "",
    };
    this.lineItem = {
      dapparameterid: 0,
      line_item_name: "",
      current_quarter: "",
      period: "",
    };
    this.route.params.subscribe((param) => {
      this.ticker = decodeURIComponent(param.ticker);
      this.researchDocId = decodeURIComponent(param.researchDocId);
      this.docInfo = null;
      this.getDocInfo();
    });
  }

  onLineitemChange(param: any): void {
    this.lineItem = { ...param.chartData };
    this.selectedTicker = { ...param.ticker };
  }

  setData(): void {
    this.companies = [...this.docInfo.symbols];
    this.brokerName = this.docInfo.publisher.broker_name;
    this.publishedDate = new Date(this.docInfo.publication_date);
    this.publisherId = this.docInfo.publisher.id;
    this.documentType = this.docInfo.mime_type;
    this.documentType =
      this.documentType === "htm" ? "html" : this.documentType.toLowerCase();
    this.tickerSelectorObj = {
      documentType: this.documentType,
      researchDocId: this.researchDocId,
      ticker: this.ticker,
    };
  }

  getDocInfo(): void {
    this.dataService
      .getResearchDocInfo([this.researchDocId])
      .subscribe((data: any) => {
        this.loading = false;
        this.docInfo = data[0];
        const primaryAnalyst = data[0].analysts.filter(
            (analyst) => analyst.isPrimary === "Yes",
          ),
          nonPrimaryAnalyst = data[0].analysts.filter(
            (analyst) => analyst.isPrimary !== "Yes",
          );
        this.analystList = [...primaryAnalyst, ...nonPrimaryAnalyst];
        this.setData();
        this.getModelsData(0, 10);
      });
  }

  onScroll(): void {
    const index = this.modelDataAPICallHead;
    const max =
      this.companies.length - index > 10 ? 10 : this.companies.length - index;
    if (max > 0 && this.modelDataAPICallCounter === 0) {
      this.getModelsData(index, max);
    }
  }

  getModelsData(index: number, max: number): void {
    const loopCompanies = this.companies.slice(0, index + max);
    this.modelDataAPICallHead = loopCompanies.length;
    this.modelDataAPICallCounter = loopCompanies.length - index;
    for (let i = index; i < loopCompanies.length; i++) {
      const modelObject = {
        company: loopCompanies[i].company_name,
        companyId: loopCompanies[i].company_id,
        date: "",
        id: "",
      };
      this.modelsData.push(modelObject);
      //this.modelsDataFilteredSorted.push(modelObject);
      this.dataService
        .getModels(this.publisherId, loopCompanies[i].company_id)
        .subscribe(
          (resp: any) => {
            if (resp.status === "success" && resp.data.length) {
              const data = resp.data[0];
              const sourceDetails = resp.source_details;
              this.modelsData[i].date = dayjs(data.event_date).format(
                "YYYY-MM-DD",
              );
              this.modelsData[i].id = data.TransactionId;
              this.modelsData[i].fileSize = data.file_size;
              this.modelsData[i].isDownloadApplicable =
                data.download_applicable;
              this.modelsData[i].isModelEntitled =
                sourceDetails.is_model_entitled;
              this.modelsData[i].fileName = data.file_name;
              this.modelsData[i].company =
                `${loopCompanies[i].company_name} Model`;
            }
            this.modelDataAPICallCounter--;
            if (this.modelDataAPICallCounter === 0) {
              this.modelsDataFilteredSorted = this.modelsData.filter((val) => {
                return val.id !== "";
              });
              this.modelsDataFilteredSorted.sort(
                (a, b) =>
                  new Date(b.date).getTime() - new Date(a.date).getTime(),
              );
            }
          },
          () => {
            this.modelDataAPICallCounter--;
            if (this.modelDataAPICallCounter === 0) {
              this.modelsDataFilteredSorted = this.modelsData.filter((val) => {
                return val.id !== "";
              });
              this.modelsDataFilteredSorted.sort(
                (a, b) =>
                  new Date(b.date).getTime() - new Date(a.date).getTime(),
              );
            }
          },
        );
    }
  }

  downloadModel(transactionId): void {
    const downloadUrl = `/api/model?TransactionId=${transactionId}&cut=INBOX`;
    const iFrameId = `research_model_download_${transactionId}`;
    this.appService.downloadFileWithIFrame(downloadUrl, iFrameId);
  }

  downloadDocument(caller): void {
    const downloadUrl = `${this.apiEP}/resapi/get_doc_download?document_id=${this.researchDocId}`;
    const iFrameId = `research_download_${this.researchDocId}`;
    this.appService.downloadFileWithIFrame(downloadUrl, iFrameId);
    const extras = {
      beginning_state_referrer: "File_viewer",
      research_id: this.researchDocId,
      research_type: this.documentType,
    };
    this.appService.logUserAction(
      {},
      this.ticker,
      "",
      `Research_Downloaded_FromViewer_${caller}`,
      extras,
      "",
      `Research_Download${caller}`,
    );
  }

  onPdfLoadEnd(): void {
    this.isPrinting = false;
  }
  showPdfLoadError(): void {
    this.message.error(`Error: Failed to load file. Please try again later.`, {
      nzDuration: 2000,
    });
    this.isPrinting = false;
  }
  printDocument(): void {
    this.isPrinting = true;
    this.dataService
      .getResearchDocument(Number(this.researchDocId))
      .subscribe((resp: PrintDocResponse) => {
        let printUrl = resp.Data.Url;
        printUrl = decodeURIComponent(printUrl);
        print({
          printable: printUrl,
          type: "pdf",
          onLoadingEnd: this.onPdfLoadEnd.bind(this),
          onError: this.showPdfLoadError.bind(this),
        });
      });
    const extras = {
      beginning_state_referrer: "File_viewer",
      research_id: this.researchDocId,
      research_type: this.documentType,
    };
    this.appService.logUserAction(
      {},
      this.ticker,
      "",
      "Research_SendToPrint",
      extras,
      "",
      "Research_Print",
    );
  }

  collapseChanged() {
    this.researchViewerComponent.resetPdf();
  }
}
